import React from "react";
import PropTypes from "prop-types";

import { Field } from "react-final-form";

const SearchFilter = ({ name }) => (
  <fieldset className="search-filter">
    <Field name={name} type="search" key={name}>
      {({ input }) => (
        <label htmlFor={input.name}>
          <input
            id={input.name}
            className="search-filter__input"
            placeholder="zoek een event of locatie"
            autoComplete="off"
            type="input"
            {...input}
          />
          <button type="submit" className="search-filter__button">
            <svg viewBox="0 0 24 24">
              <use xlinkHref="#icon-search" />
            </svg>
          </button>
        </label>
      )}
    </Field>
  </fieldset>
);

SearchFilter.propTypes = {
  name: PropTypes.string.isRequired,
};

export default SearchFilter;
